export const Top1 = () => {
    return (
        <svg width="144" height="175" viewBox="0 0 144 175" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M103.528 2.65155L74.7637 172.308H47.3968L71.1536 36.4434L28.0652 50.4943L32.3741 26.2246L99.5687 2.65155H103.528Z"
                fill="url(#paint0_linear_1274_450)"
                fillOpacity="0.4"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1274_450"
                    x1="28.0652"
                    y1="82.0216"
                    x2="115.52"
                    y2="82.0216"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.763542" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
